import { formatDate } from '@frontendmentorio/design-system-v2';

import ProLockMessage from './ProLockMessage';

export default function NoCreditsLockMessage({ currentUser }) {
  const currentDate = new Date().toISOString();

  return (
    <ProLockMessage>
      {currentUser.subscription.cancelledAt ? (
        <>
          <p align="left">
            Your subscription{' '}
            {currentUser.subscription.cancelledAt < currentDate
              ? 'was'
              : 'will be'}{' '}
            cancelled on{' '}
            <span className="font-bold">
              {formatDate(currentUser.subscription.cancelledAt)}
            </span>
            . You can reactivate your subscription by going to the billing
            settings page.
          </p>
        </>
      ) : (
        <div className="flex flex-col gap-3">
          <p>
            You’ll need to wait until your credits refresh (
            <span className="font-bold">
              {formatDate(currentUser.subscription.nextPaymentAt)}
            </span>
            ) or switch to our yearly plan to enjoy unlimited credits.
          </p>

          <p>
            Contact us at{' '}
            <a
              className="underline hover:no-underline"
              href="mailto:hi@frontendmentor.io"
            >
              hi@frontendmentor.io
            </a>{' '}
            if you would like to switch.
          </p>
        </div>
      )}
    </ProLockMessage>
  );
}
